// src/components/layout/Header.tsx
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useCustomer } from '../../contexts/CustomerContext';
import { routes, RouteConfig } from '../../config/routes';
import UserProfile from './UserProfile';
import './Layout.css';

import { NavLink, Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


const Header: React.FC = () => {
  const { user, isSignedIn } = useAuth();
  const { selectedCustomer } = useCustomer();

  const location = useLocation();

  // Filter routes to show in the main navigation
  const navRoutes = routes.filter(route => route.showInNav && !route.protected); // Public nav links
  const protectedNavRoutesOld = routes.filter(route => route.showInNav && route.protected); // Protected nav links

  // Filter routes to be shown in the nav
  const protectedNavRoutes = routes.filter(route => {
    if (!route.showInNav) return false;
    if (route.protected && !user) return false;

    // Conditionally show 'Pulse' and 'Probe' based on customer features
    if (['Pulse', 'Probe'].includes(route.name)) {
      return selectedCustomer && selectedCustomer.features?.includes(route.name.toLowerCase());
    }

    return true;
  });

  return (
    <header className="layout-header">
      {/* Left side: Home and other public links */}
      {/* <div className="flex items-center space-x-4">
        {navRoutes.map((route: RouteConfig) => (
           <Link
             key={route.path}
             to={route.path}
             // Apply consistent styling
             className={ location.pathname === route.path ? 'active-link' : 'header-link'}
           >
             {route.name}
           </Link>
        ))}
      </div> */}
      <Link to="/" className="header-link">Deriq.AI Explorer</Link>


      {/* Middle section: Protected links (only show when signed in) */}
      <div className="max-w-3xl">
        <nav className="flex space-x-4">
          {isSignedIn &&
            protectedNavRoutes.map((route: RouteConfig) => (
                <Link
                  key={route.path}
                  to={route.path}
                  // Adjusted active link logic
                  className={
                    location.pathname.startsWith(route.path.split('/:')[0]) 
                    ? 'active-link' : 'header-link'
                  }
                >
                  {route.name}
                </Link>
              ))}
        </nav>
      </div>

    {/* <nav className="nav-links">
        {navLinks.map(route => (
          <NavLink key={route.name} to={route.path} className={({ isActive }) => isActive ? 'active-link' : 'nav-link'}>
            {route.name}
          </NavLink>
        ))}
      </nav>      
    */}

      {/* Right side: Auth toggle or User Profile */}
      <div className="auth-toggle flex-shrink-0">
        {isSignedIn ? (
          <UserProfile />
        ) : (
          <Link to="/signin" className="text-orange-300 hover:text-blue-300 no-underline">
            Sign In
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;
